export default __webpack_public_path__ + "static/media/2178.f41c82b1.png";